
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * LogoutReason enum
 */
class LogoutReason {
  /**
   * Initialize enum with a given value
   * @param {LogoutReason|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof LogoutReason) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!LogoutReason}
   * @param {!LogoutReason} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof LogoutReason)) {
      throw new TypeError('Instance of LogoutReason is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!LogoutReason}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!LogoutReason}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === LogoutReason.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === LogoutReason.CLIENT_REQUEST.value) {
      return 'CLIENT_REQUEST'
    }
    if (this.value === LogoutReason.MANAGER_REQUEST.value) {
      return 'MANAGER_REQUEST'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!LogoutReason}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!LogoutReason}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!LogoutReason} Created enum
   */
  static fromObject (other) {
    return new LogoutReason(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
LogoutReason.UNKNOWN = new LogoutReason(0 + 0)
// noinspection PointlessArithmeticExpressionJS
LogoutReason.CLIENT_REQUEST = new LogoutReason(0 + 1)
// noinspection PointlessArithmeticExpressionJS
LogoutReason.MANAGER_REQUEST = new LogoutReason(0 + 2)

export { LogoutReason };

/**
 * Fast Binary Encoding LogoutReason field model
 */
class FieldModelLogoutReason extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelLogoutReason}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelLogoutReason}
   * @param {LogoutReason=} defaults Default value, defaults is new LogoutReason()
   * @returns {!LogoutReason} Result value
   */
  get (defaults = new LogoutReason()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new LogoutReason(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelLogoutReason}
   * @param {!LogoutReason} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelLogoutReason };
